import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';

import type React from 'react';

type MenuLinkProps = {
	condition?: boolean;
	to: string;
	text?: React.ReactNode;
};

export const MenuLink = ({ condition = true, to, text }: MenuLinkProps) => {
	const { menues } = useSelector((state) => state.uReducer);
	const grantedMenues = menues ? menues.split(',') : [];

	if (grantedMenues.includes('*') || condition) {
		return <NavLink to={to}>{text}</NavLink>;
	}
	return null;
};
